import { DataPackCompanyDetail } from '../../app/models/dataPackCompanyDetail.model';
import { VoiceCompanyDetail } from './voiceCompanyDetail.model';

/**
 * @author Wesley Mascarenhas
 * @version $Id: consumeView.model.ts 79367 2018-02-17 00:41:28Z thiago.h.neri $
 */
export class ConsumeView {

  public dataPackCompanyDetail: DataPackCompanyDetail;

  public voiceCompanyDetail: VoiceCompanyDetail;

  public constructor() {

  }
}


// WEBPACK FOOTER //
// ./src/app/models/consumeView.model.ts